import React from 'react';
import { twMerge } from 'tailwind-merge';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  kicker?: string;
  centered?: boolean;
  className?: string;
  light?: boolean;
}
export function SectionHeading({
  title,
  subtitle,
  kicker,
  centered = true,
  className,
  light = false
}: SectionHeadingProps) {
  return <div className={twMerge('flex flex-col', centered ? 'items-center text-center' : 'items-start text-left', className)} data-id="element-58">
      {kicker && <span className={twMerge('text-xs font-medium tracking-[0.2em] uppercase mb-4', light ? 'text-champagne' : 'text-gold')} data-id="element-59">
          {kicker}
        </span>}
      <h2 className={twMerge('text-4xl md:text-5xl lg:text-6xl mb-6 text-balance', light ? 'text-ivory' : 'text-espresso')} data-id="element-60">
        {title}
      </h2>
      {subtitle && <p className={twMerge('text-lg md:text-xl max-w-2xl font-light leading-relaxed', light ? 'text-cream' : 'text-taupe')} data-id="element-61">
          {subtitle}
        </p>}
      <div className={twMerge('w-12 h-[1px] mt-8', light ? 'bg-champagne/50' : 'bg-gold/50')} data-id="element-62" />
    </div>;
}